import { useState } from 'react';
import { AuthPanel } from '@nbirl/nbi-common-ui-libs';
import { FormikHelpers } from 'formik';

import { useAuth } from '../../../shared/context';
import { useErrorToast } from '../../../shared/hooks';
import {
  ValidateEmailForm,
  ValidateEmailFormValues,
} from './validate-email-form';

export const ValidateEmail = () => {
  const { completeValidateEmail } = useAuth();
  const { showErrorToast } = useErrorToast();
  const [isPending, setIsPending] = useState(false);

  const handleSubmit = async (
    { code }: ValidateEmailFormValues,
    formikHelpers: FormikHelpers<ValidateEmailFormValues>
  ) => {
    try {
      setIsPending(true);
      await completeValidateEmail(code);
    } catch (error: any) {
      setIsPending(false);

      if (error?.code === 'CodeMismatchException') {
        formikHelpers.setFieldError('code', 'Incorrect verification code');
      } else {
        showErrorToast(error);
      }
    }
  };

  return (
    <AuthPanel>
      <ValidateEmailForm isPending={isPending} onSubmit={handleSubmit} />
    </AuthPanel>
  );
};
